<template>
  <div>
    <ProgressDots
      class="d-none d-sm-block"
      step="3" :steps="['Accept invitation', 'Enter details', 'Choose Design', 'Place order']" />
    <b-container>
      <h1 class="d-sm-none">Choose Design</h1>
      <b-row>
        <b-col md=8 class="chooser-area">
          <div class="chooser-width">
            <TemplateChooser no-edit />
          </div>
          <ProductTemplatePreview class="preview" />
        </b-col>
        <b-col md=4 class="d-none d-md-block">
          <div class="action-card">
            <h2>Choose Your Design</h2>
            <hr/>
            <button class="btn-action sidebar-purchase-link" @click="onContinue">
              <span>Continue</span>
              <i class="fa fa-arrow-right"></i>
            </button>
          </div>
        </b-col>
      </b-row>
    </b-container>

    <div class="fixed-menu d-md-none">
      <div class="fixed-menu-body">
        <div class="btn-hint">
          <a href="mailto:support@brandly.com">Need help?</a>
        </div>
        <button class="btn-action sidebar-purchase-link" @click="onContinue">
          <span>Continue</span>
          <i class="fa fa-arrow-right"></i>
        </button>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.chooser-area {
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  padding-bottom: 2em;

  // For some reason, Bootstrap grid system
  // allows the template chooser to escape the width.
  // This is a solution that works well enough.
  max-width: calc(66vw-20px);
  @media screen and (min-width: 1140px) {
    max-width: 780px;
  }

  .chooser-width {
    max-width: 100%;
  }
  .preview {
    width: 100%;
  }
}
</style>


<script>
import {mapActions, mapGetters} from 'vuex';
export default {
  meta: {useAppHeader: true},
  mounted() {
    this.loadTeamInfo();
  },
  methods: {
    ...mapActions(['loadTeamInfo', 'startOrderFromProductTemplate']),
    async onContinue() {
      await this.startOrderFromProductTemplate();
      this.$router.push({name: 'Editor', params: {id: this.designId}});
    }
  },
  computed: mapGetters(['designId'])
}
</script>



// WEBPACK FOOTER //
// src/components/pages/homepage/ChooseDesign.vue